<template>
    <div><b>ZenArray Count:</b>{{item.children.length}} <b>Length:</b>{{$filters.hex24(item.childLength)}} <b>Data Offset:</b>{{$filters.hex24(item.dataStartOffset)}}
    <b>Extra Data:</b>{{$filters.hex24(item.extraDataLength)}}</div>
</template>

<script>
/* eslint-disable vue/no-unused-components */

export default {
    name: 'ZenArrayComponent',
    components: {
    },
    props: [
        'item'
    ]
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
